module.exports = __webpack_public_path__ + "img/top-main-view.cab98301.png";